import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { landingPathForRole } from "../../utils/navReturn";
import AuthBootScreen from "./AuthBootScreen";

export default function GuestRoute() {
  const { auth, isReady } = useAuth();
  const permissions = Array.isArray(auth?.user?.permissions) ? auth.user.permissions : [];

  if (!isReady) {
    return <AuthBootScreen />;
  }

  if (auth?.isAuthenticated) {
    return <Navigate to={landingPathForRole(auth?.user?.role, permissions)} replace />;
  }

  return <Outlet />;
}
